'use client';

import React from 'react';
import { useMedia } from 'the-platform/useMedia';

import { BREAKPOINTS } from '@webteam/breakpoints';

import { ResponsiveContext } from '@/context';

type Props = {
  children: React.ReactNode;
};

const ResponsiveProvider: React.FC<Props> = ({ children }) => {
  const isSm = useMedia(BREAKPOINTS.sm, false);
  const isMd = useMedia(BREAKPOINTS.md, false);
  const isLg = !isSm;

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ResponsiveContext.Provider value={{ isSm, isMd, isLg }}>
      {children}
    </ResponsiveContext.Provider>
  );
};

export default ResponsiveProvider;
